import en_us from './en'
import hi_IN from './he'
import ar_AE from './ar'
export default {
    en_US: en_us,
    ar_AE: ar_AE,
    hi_IN: hi_IN,
}
